import { useEffect, useRef, useState } from "react";

// Renders long lists incrementally: returns how many items to show + a sentinel ref to place at the
// end of the list. When the sentinel scrolls into view, another `step` items are revealed. Keeps the
// DOM light on 400+ row lists (Discover, shred, compliance) without a virtualization dependency.
export function useIncremental(total, step = 40) {
  const [count, setCount] = useState(Math.min(step, total));
  const ref = useRef(null);
  useEffect(() => { setCount(Math.min(step, total)); }, [total, step]);
  useEffect(() => {
    const el = ref.current;
    if (!el || count >= total) return undefined;
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) setCount((c) => Math.min(c + step, total));
    }, { rootMargin: "250px" });
    io.observe(el);
    return () => io.disconnect();
  }, [count, total, step]);
  return [count, ref];
}
